<p-dialog
  modal="true"
  position="center"
  [(visible)]="imagePreviewService.visible"
  (onHide)="closePreview()"
  [closable]="true"
  [dismissableMask]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: 'min(92vw, 960px)' }"
  styleClass="image-preview-dialog"
  [contentStyle]="{ padding: '0', overflow: 'hidden' }">
  <ng-template pTemplate="header">
    <div class="image-preview-dialog-header">
      <span
        class="image-preview-dialog-filename"
        [attr.title]="imagePreviewService.fileName || null">
        {{ imagePreviewService.fileName || ('label_image_preview' | translate) }}
      </span>
    </div>
  </ng-template>
  <div class="image-preview-dialog-body">
    <img
      [src]="imagePreviewService.previewUrl"
      class="image-preview-dialog-img"
      [alt]="imagePreviewService.fileName || 'Image preview'"
      onerror="this.src='/assets/images/temp/default_profile.png'" />
  </div>
</p-dialog>
